export default "<ion-content id=\"canvas\">\r\n</ion-content>\r\n"